import React, { FC, memo } from 'react';

import { formatDate, parseDate, yesterday } from './utils';
import {
  Container,
  DayPickerInput,
  Separation,
  DayPickerStyles,
} from './styles';
import { Props } from './types';
import useConnect from './connect';

import 'react-day-picker/lib/style.css';

const DateRangePicker: FC<Props> = ({
  fromHandleChange,
  toHandleChange,
  from,
  to,
  fromLimit,
  toLimit,
  ...props
}) => {
  const { nextInput, setNextInput } = useConnect();
  const modifiers = { start: from, end: to };

  return (
    <Container {...props}>
      <DayPickerStyles>
        <DayPickerInput
          {...props}
          value={from}
          formatDate={formatDate}
          placeholder=""
          parseDate={parseDate}
          onDayChange={fromHandleChange}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            // disabledDays: [{ after: to }, { after: yesterday }],
            // toMonth: to,
            disabledDays: [
              { after: yesterday },
              ...(fromLimit ? [{ before: fromLimit }] : []),
            ],
            toMonth: yesterday,
            modifiers,
            numberOfMonths: 2,
            onDayClick: () => nextInput && nextInput.getInput().focus(),
          }}
        />
      </DayPickerStyles>

      <Separation />

      <DayPickerStyles>
        <DayPickerInput
          {...props}
          // @ts-ignore
          ref={(element) => setNextInput(element)}
          value={to}
          formatDate={formatDate}
          placeholder=""
          parseDate={parseDate}
          onDayChange={toHandleChange}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
            disabledDays: [
              { before: from },
              { after: yesterday },
              ...(toLimit ? [{ after: toLimit }] : []),
            ],
            modifiers,
            month: from,
            fromMonth: from,
            numberOfMonths: 2,
          }}
        />
      </DayPickerStyles>
    </Container>
  );
};

export default memo(DateRangePicker);
